<template>
  <Modal :value="value" title="修改密码" class="vertical-center-modal" :width="400"
    @on-visible-change="onVisible">
    <Form ref="form" :model="form" :rules="rules" :label-width="80">
      <FormItem label="原始密码" prop="oldPwd">
        <Input v-model="form.oldPwd" type="password" password placeholder="请输入原始密码" />
      </FormItem>
      <FormItem label="新密码" prop="newPwd">
        <Input v-model="form.newPwd" type="password" password placeholder="请输入8-16位大小写字母和数字的新密码" />
      </FormItem>
      <FormItem label="确认密码" prop="confirmPwd">
        <Input v-model="form.confirmPwd" type="password" password placeholder="请再次输入新密码" />
      </FormItem>
    </Form>
    <template #footer>
      <dialog-footer @cancel="close" @confirm="submit" />
    </template>
  </Modal>
</template>

<script>
export default {
  name: 'ChangePasswordDialog',
  props: { value: { type: Boolean, default: false } },
  data() {
    const checkConfirm = (rule, val, cb) =>
      val !== this.form.newPwd ? cb(new Error('两次密码不一致')) : cb()
    return {
      form: { oldPwd: '', newPwd: '', confirmPwd: '' },
      rules: {
        oldPwd: [{ required: true, message: '请输入原始密码', trigger: 'blur' }],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,16}$/, message: '8-16位含大小写字母和数字', trigger: 'blur' }
        ],
        confirmPwd: [{ required: true, validator: checkConfirm, trigger: 'blur' }]
      }
    }
  },
  methods: {
    onVisible(v) { if (!v) this.close() },
    close() { this.$refs.form && this.$refs.form.resetFields(); this.$emit('input', false) },
    submit() {
      this.$refs.form.validate((ok) => {
        if (!ok) return
        // TODO: 调修改密码接口
        this.$Message.success('密码已修改(待接口)')
        this.close()
      })
    }
  }
}
</script>
